import { useNullableDealerAccountInfo } from "../../../../stores/hooks/useNullableDealerAccountInfo";
import { DealerEnableXtimeAppointmentIntegrationShow } from "../../../../stores/slices/dealerAccountInfoSlice";

export const useXtimeAppointmentState = (): boolean => {
  const dealerAccountInfo = useNullableDealerAccountInfo();
  return (
    dealerAccountInfo?.dealerEnableXtimeAppointmentIntegration ===
    DealerEnableXtimeAppointmentIntegrationShow
  );
};
